import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-data-sync-settings',
  templateUrl: './data-sync-settings.component.html',
  styleUrls: ['./data-sync-settings.component.scss'],
  standalone: false,
})
export class DataSyncSettingsComponent implements OnInit {
  public types = [{ id: 1, name: 'Типы заявок' }];
  public typeSelected;

  @Input() settings;

  constructor() {}

  ngOnInit() {}

  onChangeTypeSelected(type): void {
    this.typeSelected = type;
  }
}
